import { postApi } from "./getApiBase";
import { jwtSign } from "./jwt";

type validateArgs = {
  walletAddress: string;
  codeword: string;
};

export const validateCodeWord = async (args: validateArgs) => {
  const encrypted = jwtSign(args);

  const codewordRes = await postApi("validate-codeword", encrypted);

  return await codewordRes.json();
};

type CodewordArgs = {
  id: number;
  email: string;
  walletAddress: string;
  acceptsMarketing: boolean;
};
export const generateCodeWord = async (user: CodewordArgs) => {
  const encrypted = jwtSign(user);
  const codewordRes = await postApi("generate-code-word", encrypted);

  return await codewordRes.json();
};
